import {gql} from "@irati/utils/gql"
import partialUser from "@irati/identity/services/fragments/PartialUser"
const fragment = gql`
  fragment GroupCelebrationMessage on GroupCelebrationMessage {
    uuid
    createdBy {
      ...partialUser
    }
    message
    moderated
  }
  ${partialUser}
`

export default fragment
